import GeneralPostInfo from './generalPostInfo';

export default GeneralPostInfo;
